import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import {
    getAccessListFiltersItems,
    createNewAccessListFiltersItem,
    modifyAccessListFiltersItem,
    removeAccessListFiltersItem,

    getAccessListNotificationSettings,
    unsetAccessListNotificationSettings,
    modifyAccessListNotificationSettings
} from "actions/accounts";
import {
    getAuthNumberType
} from "actions/auth_numbers";
import AccessListFilters from "./AccessListFilters";


const AccessListFiltersContainer = ({
    data,
    service,
    roleList,
    page,
    loading,
    perPage,
    worldzoneList,
    destinationList,
    subdestinationList,
    numberTypeFamilyList,
    accessListNotificationSettings,

    getAuthNumberType,
    getAccessListFiltersItems,
    removeAccessListFiltersItem,
    modifyAccessListFiltersItem,
    createNewAccessListFiltersItem,
    getAccessListNotificationSettings,
    unsetAccessListNotificationSettings,
    modifyAccessListNotificationSettings,
    ...props
}) => {
    const getAccessListFiltersItemsByAccountId = (accountId) => {
        getAccessListFiltersItems(service, accountId);
    };

    const modifyAccessListNotificationSettingsById = async (id, data) => {
        return await modifyAccessListNotificationSettings(id, data);
    };

    return (
        <>
            <AccessListFilters
                accountId={props.match.params.id}
                service={service}
                data={data}
                roleList={roleList}
                page={page}
                perPage={perPage}
                loading={loading}

                notificationSettings={accessListNotificationSettings}

                worldzoneList={worldzoneList}
                destinationList={destinationList}
                subdestinationList={subdestinationList}

                getNotificationSettings={getAccessListNotificationSettings}
                unsetNotificationSettings={unsetAccessListNotificationSettings}
                modifyNotificationSettings={modifyAccessListNotificationSettingsById}

                getItems={getAccessListFiltersItemsByAccountId}
                createApiFunc={createNewAccessListFiltersItem}
                modifyApiFunc={modifyAccessListFiltersItem}
                removeApiFunc={removeAccessListFiltersItem}
                getAuthNumberType={getAuthNumberType}
                numberTypeFamilyList={numberTypeFamilyList}
            />
        </>
    );
};

const mapStateToProps = ({ auth, roles, accounts, references, auth_numbers }) => {
    return {
        service: auth.service,

        roleList: roles.role_list,

        data: accounts.accessListFiltersList,
        loading: accounts.accessListFiltersListLoading,
        accessListNotificationSettings: accounts.accessListNotificationSettings,

        worldzoneList: references.worldzone_list,
        destinationList: references.destination_list,
        subdestinationList: references.subdestination_list,

        numberTypeFamilyList: auth_numbers.auth_number_type_family_list,
    };
};

export default compose(
    connect(mapStateToProps, {
        getAccessListFiltersItems,
        removeAccessListFiltersItem,
        createNewAccessListFiltersItem,
        modifyAccessListFiltersItem,

        getAccessListNotificationSettings,
        unsetAccessListNotificationSettings,
        modifyAccessListNotificationSettings,

        getAuthNumberType
    }),
    withRouter
)(AccessListFiltersContainer);